import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs';
import { BasePage } from '../BasePage';

@Component({
  selector: 'app-reroute-page',
  templateUrl: './reroute-page.component.html',
  standalone: false,
})
export class ReroutePageComponent extends BasePage {
  /* 
  Use this to force the reload a component when already on that component.

  First use case: end impersonation and reload the user's dashboard.

  Using a custom routing strategy seemed to mess up all of the routes, so this
  seemed like the next best thing.
  */

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
    super();

    let r = this.route.queryParams.pipe(map((p) => p['route']));
    r.subscribe((value) => {
      this.router.navigateByUrl(value);
    });
  }
}
